module.exports = __webpack_public_path__ + "img/amex-payment-icon.60134ad7.svg";